import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { SafeAreaView, StyleSheet, View, TextInput, ActivityIndicator, TouchableOpacity, Image, Platform, Linking } from 'react-native';
import { Button, Input, Colors, Routes, Cards, Text, Screen, ApplePay, Line } from '../components';
import { LandingSliders } from '../containers';
import AuthController from '../controllers/authController';
import UtilitiesController from '../controllers/utilitiesController';
import { Link } from "react-router-native";
import { useNavigate } from 'react-router-dom';

class LandingScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }

    this.getStarted = this.getStarted.bind(this);
  }

  componentDidMount = async () => {
    let user      = await AuthController.getUser(true);
    await AuthController.startSignupSession();

    if (Platform.OS === 'web') {
      let page_url = window.location.href;
      let params   = (new URL(page_url)).searchParams;
      let clickId  = params.get("irclickid");
      let impact_click_id = clickId || '';

      if (impact_click_id) {
        await AsyncStorage.setItem('impact_click_id', impact_click_id);
      }
    }
  }

  render_landing_slide = (image_source, description, extra_height) => {
    let height           = Platform.OS === 'web' ? 460 : '100%';
    let image_dimensions = Platform.OS === 'web' ? 200 : 300;
    return <View style={{ height: height, backgroundColor: 'white', borderRadius: 14 }}>
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
              <Image resizeMode='contain' style={{ width: image_dimensions + 50, height: image_dimensions }} source={ image_source } />
            </View>
            <View style={{ padding: 20, paddingLeft: 25, paddingRight: 25, height: extra_height? 215 : 180 }}>
              <Text style={{ fontSize: 26, fontWeight: '500', color: 'black', flex: 1 }}>{ description }</Text>
            </View>
          </View>
  }

  render_landing_slide_1 = (image_source, description, extra_height) => {
    let height           = Platform.OS === 'web' ? 460 : '100%';
    let image_dimensions = Platform.OS === 'web' ? 150 : 250;
    return <View style={{ height: height, backgroundColor: 'white', borderRadius: 14 }}>
            <View style={{ paddingTop: 40, marginBottom: 10 }}>
              <Text style={{ fontWeight: '500', fontSize: 24, color: '#404040', textAlign: 'center' }}>Welcome To</Text>
            </View>
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Image resizeMode='contain' style={{ width: image_dimensions + 50, height: image_dimensions }} source={ image_source } />
            </View>
            <View style={{ padding: 20, paddingLeft: 25, paddingRight: 25, height: 100 }}>
              <Text style={{ fontSize: 24, fontWeight: '500', color: '#404040', flex: 1, textAlign: 'center' }}>{ description }</Text>
            </View>
            <View style={{ padding: 20, paddingLeft: 25, paddingRight: 25, alignItems: 'center' }}>
              <Text style={{ fontSize: 17 }}>{ 'Live chat, audio and video sessions with a vet pro, no appointments necessary' }</Text>
            </View>
          </View>
  }

  render_landing_slide_2 = (image_source, description, extra_height) => {
    let height           = Platform.OS === 'web' ? 460 : '100%';
    let image_dimensions = Platform.OS === 'web' ? 180 : 210;
    return <View style={{ height: height, backgroundColor: 'white', borderRadius: 14 }}>
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Image resizeMode='contain' style={{ width: image_dimensions + 50, height: image_dimensions }} source={ image_source } />
            </View>
            <View style={{ paddingLeft: 25, paddingRight: 25, alignItems: 'center', marginTop: 40 }}>
              <Text style={{ fontSize: 17, flex: 1, fontWeight: '500' }}>{ 'Avoid a stressful trip to the vet — ask our trusted team about:' }</Text>
            </View>
            <View style={{ paddingLeft: 25, paddingRight: 25, alignItems: 'center', marginTop: 20 }}>
              <View>
                <Text style={{ fontSize: 17 }}>{ '•  Medical issues' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Behavioral concerns' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Nutrition' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Dental care' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  And more!' }</Text>
              </View>
            </View>
          </View>
  }

  render_landing_slide_3 = (image_source, description, extra_height) => {
    let height           = Platform.OS === 'web' ? 460 : '100%';
    let image_dimensions = Platform.OS === 'web' ? 180 : 210;
    return <View style={{ height: height, backgroundColor: 'white', borderRadius: 14 }}>
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Image resizeMode='contain' style={{ width: image_dimensions + 100, height: image_dimensions }} source={ image_source } />
            </View>
            <View style={{ paddingLeft: 25, paddingRight: 25, alignItems: 'center', marginTop: 40 }}>
              <Text style={{ fontSize: 17, flex: 1, fontWeight: '500' }}>{ 'All pets welcome! We support:' }</Text>
            </View>
            <View style={{ paddingLeft: 25, paddingRight: 25, alignItems: 'center', marginTop: 20 }}>
              <View>
                <Text style={{ fontSize: 17 }}>{ '•  Dogs' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Cats' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Guinea Pigs' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Hamsters' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Lizards' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  Birds' }</Text>
                <Text style={{ fontSize: 17 }}>{ '•  And more!' }</Text>
              </View>
            </View>
          </View>
  }

  render_landing_slide_4 = (image_source, description, extra_height) => {
    let height           = Platform.OS === 'web' ? 460 : '100%';
    let image_dimensions = Platform.OS === 'web' ? 180 : 210;
    return <View style={{ height: height, backgroundColor: 'white', borderRadius: 14 }}>
            <View style={{ justifyContent: 'center', alignItems: 'center', paddingTop: 10 }}>
              <Image resizeMode='contain' style={{ width: image_dimensions + 100, height: image_dimensions - 10 }} source={ image_source } />
            </View>
            <View style={{ paddingLeft: 25, paddingRight: 25, alignItems: 'center', marginTop: 40 }}>
              <Text style={{ fontSize: 17, flex: 1, fontWeight: '500' }}>{ 'Subscribe to DodoVet to be the best pet parent you can be.' }</Text>
            </View>
            <View style={{ paddingLeft: 25, paddingRight: 25, alignItems: 'center', marginTop: 20 }}>
              <View>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ fontSize: 17, marginRight: 10 }}>{ '•' }</Text>
                  <Text style={{ fontSize: 17 }}>{ 'Connect with an empathetic vet pro who will get to know you and your pet' }</Text>
                </View>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ fontSize: 17, marginRight: 10 }}>{ '•' }</Text>
                  <Text style={{ fontSize: 17 }}>{ 'Get the latest wellness advice personalized just for your pet' }</Text>
                </View>
              </View>
            </View>
          </View>
  }

  render_landing_slide = (image_source) => {
    let height           = Platform.OS === 'web' ? 330 : 330;
    let image_dimensions = Platform.OS === 'web' ? 330 : 330;
    return <View style={{ height: height, backgroundColor: 'white', borderRadius: 14 }}>
            <View style={{ justifyContent: 'center', alignItems: 'center', paddingTop: 10 }}>
              <Image resizeMode='contain' style={{ width: image_dimensions + 100, height: image_dimensions - 10 }} source={ image_source } />
            </View>
          </View>
  }

  render_landing_sliders = () => {
    let component_stuff = [ this.render_landing_slide( require('../assets/images/landing-slide-1.png')),
                            this.render_landing_slide( require('../assets/images/landing-slide-2.png')),
                            this.render_landing_slide( require('../assets/images/landing-slide-3.png')),
                            this.render_landing_slide( require('../assets/images/landing-slide-4.png')),
                            this.render_landing_slide( require('../assets/images/landing-slide-5.png'))
                          ]
    return <View style={{ width: '100%' }}>
      <Cards data={component_stuff} dots={true} display_next_button={true} last_card_action={ this.getStarted }/>
    </View>
  }

  getStarted = async () => {
    await AuthController.clearSignUpSession();
    this.props.navigate(`${Routes.SIGN_UP}`)
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  render_bottom_buttons = (navigate) => {
    let is_web = Platform.OS === 'web';
    return <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20, paddingTop: 10 }}>
      <View>
        { /* <Button title='Get Started' style={{ width: 330, marginBottom: 10 }} onPress={this.getStarted}/> */ }
      </View>
      <View style={{ flexDirection: 'row' }}>
        <Text style={{ fontSize: 16, color: 'grey' }}>Already have an account?</Text>
        {Platform.OS === 'web' ?
        <TouchableOpacity style={{ paddingRight: 8, paddingLeft: 8 }} onPress={()=>this.props.navigate(Routes.SIGN_IN)} ><Text style={{ fontSize: 16, fontWeight: 'bold', color: Colors.PRIMARY }}>Sign In</Text></TouchableOpacity> :
        <TouchableOpacity style={{ paddingRight: 8, paddingLeft: 8 }} onPress={()=>this.props.navigate(Routes.SIGN_IN)} ><Text style={{ fontSize: 16, fontWeight: 'bold', color: Colors.PRIMARY }}>Sign In</Text></TouchableOpacity>}
      </View>

      { is_web ? <View style={{ width: '100%', marginTop: 15 }}>
        <Line style={{ marginBottom: 15 }}/>
        <View style={{ flexDirection: 'column', width: '100%', alignItems: 'center' }}>
          <View style={{ flexDirection: 'row', marginBottom: 15 }}>
            <Text style={{ fontSize: 14, color: 'grey' }}>Need more info? See our</Text>
            <Text style={{ fontSize: 14, fontWeight: 'bold', color: Colors.PRIMARY, marginLeft: 5 }}
                  onPress={ () => {
                    Linking.openURL('https://www.thedodo.com/dodovet')
                  }}>FAQs</Text>
          </View>
          <View>
            <TouchableOpacity style={{ paddingRight: 8, paddingLeft: 8 }}
                              onPress={() => { Linking.openURL('mailto:support@dodovet.com?subject=Contact%20DodoVet%20Support') }} >
              <Text style={{ fontSize: 14, fontWeight: 'bold', color: Colors.PRIMARY }}>Contact Support</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View> : null }

    </View>
  }

  render() {
    return (
      <Screen navigation={this.props.navigation} hide_nav_bar={true} scroll={true}>


        { Platform.OS === 'web' || true ? null : <View style={{ width: "100%", alignItems: 'center' }}>
          <View style={{ paddingRight: 20, paddingLeft: 20, paddingTop: 10, paddingBottom: 10, borderRadius: 15 }}>
            <Image style={{ height: 35, width: 200 }} resizeMode='contain' source={ require('../assets/images/dodovet-top-logo.png') } />
          </View>
        </View> }

        <View style={{ height: 30 }}></View>
        { this.render_landing_sliders() }
        { this.render_bottom_buttons()  }
        {/* <ApplePay price={10} period={'month'}  onSubscriptionCompleted={()=>{alert('subscription completed');}} /> */}
      </Screen>
    );
  }
}

function LandingScreen(props) {
  if(Platform.OS === 'web') {
    let navigate = useNavigate();
    return <LandingScreen_Base {...props} navigate={navigate}  />
  } else {
    //
    return  <LandingScreen_Base {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({

});

export default LandingScreen
